import { useRef } from "react";
import ReducedIndividualPerson from "./ReducedIndividualPerson";
import { AffectedIndividualsType } from "../../static/types/commonTypes/affectedIndividualsType";
import { initialAffectedIndividualsState } from "../../static/initialState/commonInitialState/initialAffectedIndividualsState";
import DateOfBirthAndCityComponent from "./DateOfBirthAndCity";

type AffectedIndividualsListProps = {
  checked: boolean;
  individuals: AffectedIndividualsType[];
  addButtonText: string;
  removeButtonText: string;
  labelItem?: string;
  setIndividuals: (individuals: AffectedIndividualsType[]) => void;
  setIndividualsValidity: (isValid: boolean) => void;
};

type ValidationEntry = {
  person: boolean;
  dob: boolean;
};

export default function AffectedIndividualsList({
  checked,
  individuals,
  addButtonText,
  removeButtonText,
  labelItem,
  setIndividuals,
  setIndividualsValidity,
}: AffectedIndividualsListProps) {
  
  
  let listValidity: ValidationEntry[] = [{ person: false, dob: false }]

  const addIndividual = () => {
    setIndividuals([...individuals, initialAffectedIndividualsState]);
    listValidity.push({ person: false, dob: false });
    console.log( individuals )
  };

  const removeLastIndividual = () => {
    if (individuals.length > 1) {
      setIndividuals(individuals.slice(0, -1));
      if (listValidity.length > 1) {
        listValidity.slice( 0, -1 );
      }
    }
  };

  const updateIndividual = (index: number, updatedIndividual: AffectedIndividualsType) => {
    const newIndividuals = [...individuals];
    newIndividuals[index] = updatedIndividual;
    setIndividuals(newIndividuals);
  };

  const updateValidation = (index: number, updated: Partial<ValidationEntry>) => {
    listValidity[index] = { ...listValidity[index], ...updated };
    setIndividualsValidity(listValidity.every((v) => v.person && v.dob));
  };

  return (
    <>
      <div className="row mt-3">
        {individuals.map((individual, index) => (
          <div key={index} className="tab-content mb-2">
            <div className="mb-3 row pt-3">
              <div className="col-sm-6">
                {labelItem && <h6 className="text-bold">{`${labelItem} ${index + 1}`}</h6>}
              </div>
            </div>

            <ReducedIndividualPerson
              checked={checked}
              reducedIndividualPerson={{
                civility: individual.civility,
                firstName: individual.firstName,
                lastName: individual.lastName,
              }}
              onValidationChange={(isValid: boolean) =>
                updateValidation(index, { person: isValid })
              }
              changeReducedIndividualPerson={(details) => {
                const updated = { ...individual, ...details };
                updateIndividual(index, updated);
              }}
            />

            <DateOfBirthAndCityComponent
              checked={checked}
              index = { index }
              dateOfBirth={{
                dateOfBirth: individual.dateOfBirth,
                postalCode: individual.postalCode,
                cities: individual.cities,
                city: individual.city,
              }}
              onValidationChange={(isValid: boolean) =>
                updateValidation(index, { dob: isValid })
              }
              onChange={(details) => {
                const updated = { ...individual, ...details };
                updateIndividual(index, updated);
              }}
            />
          </div>
        ))}
      </div>

      <div className="row mb-3">
        <div className="col d-flex justify-content-center align-items-center gap-5">
          <button type="button" onClick={addIndividual}>
            {addButtonText}
          </button>
          {individuals.length > 1 && (
            <button type="button" onClick={removeLastIndividual}>
              {removeButtonText}
            </button>
          )}
        </div>
      </div>
    </>
  );
}
